import React, { useEffect } from "react";
import Card from "../../../components/Global/Card";
import { FaShoppingCart } from "react-icons/fa";
import { FaPlusCircle } from "react-icons/fa";
import GoBack from "../../../components/Utils/GoBack";
import RegisteProductForm from "../../../components/Forms/RegisterProductForm";

function RegisterProduct() {
  return (
    <div className="flex flex-col w-full gap-3">
      <GoBack path="/colaboradores" />
      <Card title="Adicionar Novo Produto" icon={<FaPlusCircle className="w-[25px] h-[25px]" />}>
        <div className="p-4 flex flex-col gap-5 w-full">
          <RegisteProductForm/>
        </div>
      </Card>
    </div>
  );
}

export default RegisterProduct;